<div class="panel-container">
    <p-button (onClick)="togglePanel($event)"
              [style]="buttonStyle() ??{padding: '8px 15px', 'border-radius': '18px',
               'background-color': 'var(--atlas-orange)', 'border-color': 'var(--atlas-orange)'}"
              [class.overlay]="isOverlay()">
              @if(buttonIcon() === PanelButtonIcon.Info) {
                <img src="assets/icons/info-no-background.svg" alt=""/>
              } @else if (buttonIcon() === PanelButtonIcon.Lightbulb) {
                <i class="pi pi-lightbulb"></i>
              }
      <span class="bold">{{buttonLabel()}}</span> {{buttonLabelSuffix()}}</p-button>

    <!--eslint-disable-next-line-->
    <div class="panel-inner-container"
         (click)="onInnerContainerClick($event)"
         (keydown)="onInnerContainerClick($event)"
         [style.width]="innerWidth"
         [class]="{hidden: !show, overlay: isOverlay()}">
        <div class="arrow" [class]="position()"></div>
        <div class="content-container">
            <p-button [text]="true" ariaLabel="Sluit het paneel Deel mijn score"
                      (onClick)="hidePanel()">
                <i class="pi pi-times" style="color: var(--gm-neutral-400)"></i>
            </p-button>
            <div class="content">
                <ng-content />
            </div>
        </div>
    </div>
</div>
